module.exports = __webpack_public_path__ + "img/pdf.1843fc12.png";